enum ORDER_CONSTANTS {
    CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST",
    CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS",
    CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL",
    CREATE_ORDER_RESET = "CREATE_ORDER_RESET",
    CREATE_ORDER_OFFLINE = "CREATE_ORDER_OFFLINE",
    
    GET_ORDERS_BY_CLIENT_REQUEST = "GET_ORDERS_BY_CLIENT_REQUEST",
    GET_ORDERS_BY_CLIENT_SUCCESS = "GET_ORDERS_BY_CLIENT_SUCCESS",
    GET_ORDERS_BY_CLIENT_FAIL = "GET_ORDERS_BY_CLIENT_FAIL",

    GET_ORDERDETAIL_BEGIN = "GET_ORDERDETAIL_BEGIN",
    GET_ORDERDETAIL_ERROR = "GET_ORDERDETAIL_ERROR",
    GET_ORDERDETAIL_SUCCESS = "GET_ORDERDETAIL_SUCCESS",

    CANCEL_ORDER_BEGIN = "CANCEL_ORDER_BEGIN",
    CANCEL_ORDER_ERROR = "CANCEL_ORDER_ERROR",
    CANCEL_ORDER_SUCCESS = "CANCEL_ORDER_SUCCESS"
}

export default ORDER_CONSTANTS;